// extracted by mini-css-extract-plugin
module.exports = {"Menu":"Menu_Menu__1eX3V","isOpen":"Menu_isOpen__2ctyh","disabled":"Menu_disabled__3xrcB"};